enum TooniesCampaignTab {
  TooniesSwap = "Toonies Swap",
}

export default TooniesCampaignTab;
